import script from "./EmojisAndGiphs.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmojisAndGiphs.vue?vue&type=script&setup=true&lang=ts"

import "./EmojisAndGiphs.vue?vue&type=style&index=0&id=6c770bbd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c770bbd"]])

export default __exports__